import React from 'react';
import _ from 'lodash';

import { CcusTable } from './tables/CcusTable';

const columns = [
  {
    name: '会社名',
    classname: 'col',
  },
  {
    name: '支店',
    classname: 'col',
  },
  {
    name: 'ユーザー名',
    classname: 'col',
  },
  {
    name: 'ID',
    classname: 'col-30',
  },
];

export const CcusListUsers = ({ data, isRolePartner, editUser }) => {
  return (
    <div className='multi-table ccus-multi-table'>
      <div className='text-description'>
        {isRolePartner
          ? 'CCUSから事業者情報、技能者情報の取得が可能となる連携ユーザーを設定してください。'
          : 'CCUSへの現場情報の登録および取得、施工体制の登録が可能となる連携ユーザーを設定してください。'}
      </div>
      {_.isEmpty(data) && (
        <div className='text-description red-label'>
          連携ユーザーが未登録です。ユーザーを登録してください。
        </div>
      )}
      <div className='multi-table__table'>
        <CcusTable
          data={data}
          columns={columns}
          tableType={'company'}
          isRolePartner={isRolePartner}
        />
        {_.isEmpty(data) && (
          <div className='table-has-no-data'>
            <div className='table-has-no-data__message'>
              ユーザーが登録されていません。
            </div>
          </div>
        )}
        <button className='btn' onClick={editUser}>
          {!_.isEmpty(data) ? '連携ユーザーを編集' : '連携ユーザーを登録'}
        </button>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/CcusListUsers.jsx